module.exports = __webpack_public_path__ + "img/116.2492d32b.jpg";